import type { ToastType } from '../types.js';

/// Toast-stack per kravspec §15.15. Auto-dismiss, max 3 i stak, ældste
/// erstattes når en 4. lander. XSS-safe: msg sættes via textContent.

export interface IToastService {
  show(msg: string, type?: ToastType): void;
}

interface ToastOptions {
  ttlMs: number;
  iconName: string;
}

export class ToastService implements IToastService {
  private static readonly OPTIONS: Record<ToastType, ToastOptions> = {
    success: { ttlMs: 2800, iconName: 'check-circle' },
    info:    { ttlMs: 2800, iconName: 'info' },
    error:   { ttlMs: 4000, iconName: 'x-circle' },
  };

  private static readonly MAX_STACKED = 3;
  private static readonly FADE_OUT_MS = 200;

  constructor(private readonly doc: Document = document) { }

  show(msg: string, type: ToastType = 'success'): void {
    const stack = this.ensureStack();
    while (stack.childElementCount >= ToastService.MAX_STACKED && stack.firstElementChild) {
      stack.removeChild(stack.firstElementChild);
    }

    const { ttlMs, iconName } = ToastService.OPTIONS[type];

    const t = this.doc.createElement('div');
    t.className = `toast toast-${type}`;
    t.innerHTML = `<i class="ph ph-${iconName}"></i><span></span>`;
    t.querySelector('span')!.textContent = msg;
    stack.appendChild(t);

    setTimeout(() => {
      t.classList.add('toast-out');
      setTimeout(() => t.remove(), ToastService.FADE_OUT_MS);
    }, ttlMs);
  }

  private ensureStack(): HTMLElement {
    const existing = this.doc.getElementById('toast-stack');
    if (existing) return existing;

    const created = this.doc.createElement('div');
    created.id = 'toast-stack';
    created.className = 'toast-stack';
    this.doc.body.appendChild(created);
    return created;
  }
}
